module.exports = __webpack_public_path__ + "img/caution_red.8d4fdddf.svg";